import { type Memberships } from './collections/memberships'

export const employeeMemberships = (memberships: Memberships, employeeId: number) => {
  return memberships.filter({
    employee_id: employeeId,
  })
}
